export default __webpack_public_path__ + "static/media/screen7.94075c75.png";